import React from "react";
// import { Navigate } from "react-router-dom";

import Home from "../pages/home";
import NewsEvents from "../pages/news";
import NewsDetails from "../pages/news/news-details";
import Events from "../pages/events/index";
import EventDetails from "../pages/events/event-details";
import EventDetailsStatic from "../pages/events/event-details-final-backup";
import Careers from "../pages/careers/";
import People from "../pages/people";
import PeopleDetails from "../pages/people/people-details";
import Research from "../pages/research";
// import GESHProject from "../pages/research/gesh-projects";
import Publications from "../pages/research/publications";
import Publications2022 from "../pages/research/publications-2022";

import AboutUs from "../pages/aboutus";
import OURPartners from "../pages/partnerships/our-partners";
import MappedResearch from "../pages/research/mapped-category-deatils";
import PeopleDepartment from "../pages/people/people-department";
import Search from "../pages/layout/searchresults";
import Sitemap from "../pages/sitemap";
import PageNotFound from "../pages/errorDocs/pageNotFound";
import ErrorPage from "../pages/layout/errorPage";
import CampusSustainability from "../pages/campus-sustainability";
import Initiatives from "../pages/campus-sustainability/initiatives";
import GESHIITBLLP from "../pages/campus-sustainability/gesh-iitb-living-lab-program";
import GESHfellows from "../pages/campus-sustainability/gesh-fellows";
import GESHProjects from "../pages/campus-sustainability/projects";
import Services from "../pages/services";
import FocusAreas from "../pages/focus-areas";
import Blog from "../pages/blog";
import BlogDetails from "../pages/blog/details";

// Static Version
import GESHProject1 from "../pages/research/gesh-project1";
import GESHProjectdestailsStatic from "../pages/research/gesh-project-details1";

import GESHProject from "../pages/research/gesh-projects";
import GESHProjectdestails from "../pages/research/geshproject-details";

import FocusAreas1 from "../pages/focus-areas/index1";
import ResearchSearchResults from "../pages/research/research-search-results";
import ThankYouPage from "../pages/layout/thankyou";

import Partners from "../pages/outreach/partners";
import IITBCourses from "../pages/education";
import SustainabilityLeadership from "../pages/education/professional-certificate-in-sustainability-leadership";
import { components } from "react-select";

const websiteRoutes = [
  { path: "/", component: <Home /> },
  { path: "/home", component: <Home /> },

  { path: "/events", component: <Events /> },
  { path: "/events/:evertical_pagename", component: <Events /> },
  { path: "/event-details/:event_pagename", component: <EventDetails /> },
  { path: "/event-details-static", component: <EventDetailsStatic /> },

  // { path: "/news/:news_type_pagename", component: <NewsEvents /> },
  // { path: "/news/:news_type_pagename/:page_name", component: <NewsDetails /> },

  { path: "/news", component: <NewsEvents /> },
  { path: "/news-details/:page_name", component: <NewsDetails /> },
  { path: "/careers", component: <Careers /> },
  { path: "/people/:pcategory_pagename", component: <People /> },
  {
    path: "/people/:pcategory_pagename/:ps_category_pagename",
    component: <PeopleDetails />,
  },
  {
    path: "/people/:pcategory_pagename/:ps_category_pagename/:department_pagename",
    component: <PeopleDepartment />,
  },
  { path: "/research", component: <Research /> },
  // { path: "/research-projects", component: <GESHProjects /> },
  // {
  //   path: "/research-projects/:rtype_pagename",
  //   component: <GESHProjectDetails />,
  // },
  // { path: "/research/:rcategory_pagename", component: <MappedResearch /> },

  { path: "/publications", component: <Publications /> },
  { path: "/publications-2022", component: <Publications2022 /> },
  { path: "/aboutus", component: <AboutUs /> },
  { path: "/ourpartners", component: <OURPartners /> },

  { path: "/campus-sustainability", component: <CampusSustainability /> },
  { path: "/campus-sustainability/initiatives", component: <Initiatives /> },
  { path: "/campus-sustainability/gesh-iitb-living-lab-program", component: <GESHIITBLLP /> },
  { path: "/campus-sustainability/gesh-fellows", component: <GESHfellows /> },
  { path: "/campus-sustainability/projects/:project_pagename?", component: <GESHProjects /> },
  { path: "/services", component: <Services /> },
  { path: "/focus-areas/index1", component: <FocusAreas /> },

  { path: "/search-result/:str", component: <Search /> },

  { path: "/knowledge-hub", component: <Blog /> },
  { path: "/knowledge-hub/:blog_year", component: <Blog /> },
  { path: "/knowledge-hub-category/:blog_category_pagename", component: <Blog /> },
  { path: "/knowledge-hub-authors/:blog_author_pagename", component: <Blog /> },
  { path: "/knowledge-hub-tags/:blog_tags_pagename", component: <Blog /> },
  { path: "/knowledge-hub-search/:blog_search", component: <Blog /> },
  { path: "/knowledge-hub-details/:blog_pagename", component: <BlogDetails /> },

  { path: "/sitemap", component: <Sitemap /> },

  { path: "/error-page", component: <ErrorPage /> },
  { path: "*", component: <PageNotFound /> },

  { path: "/research/gesh-project1", component: <GESHProject /> },
  { path: "/research/gesh-project-details1", component: <GESHProjectdestailsStatic /> },

  { path: "/research-projects/:rtype_pagename", component: <GESHProject />, },

  { path: "/research-projects/search-result", component: <ResearchSearchResults />, },

  { path: "/research-projects/:rtype_pagename/:res_pagename", component: <GESHProjectdestails />, },

  { path: "/focus-areas", component: <FocusAreas1 /> },

  { path: "/contact/thank-you", component: <ThankYouPage /> },

  { path: "/outreach/partners", component: <Partners /> },
  { path: "/education/", component: <IITBCourses /> },
  { path: "/education/professional-certificate-in-sustainability-leadership", component: <SustainabilityLeadership /> },
];

export { websiteRoutes };
